/* unplugin-vue-components disabled */import script from "./TrialSimOrderBurst.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialSimOrderBurst.vue?vue&type=script&setup=true&lang=js"

import "./TrialSimOrderBurst.vue?vue&type=style&index=0&id=c485fa94&scoped=true&lang=css"

import exportComponent from "../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c485fa94"]])

export default __exports__